module.exports = __webpack_public_path__ + "img/777.6600fc92.png";